export const parseJSON = (json: string) => {
  try {
    return JSON.parse(json);
  } catch (e) {
    return json;
  }
};
